import Vue from 'vue'
import axios from '@/plugins/axios'

export const find = async ({ commit }, { automationId, params = {} }) => {
  try {
    const { data } = await axios.get(`service-automation/${automationId}/actions`, {
      params,
    })

    if (data && data.actions) {
      commit('setRows', data.actions)
      return data.actions
    }

    commit('setRows', [])
    return []
  } catch (err) {
    console.error('Erro ao buscar ações da automação de serviço:', err)
    commit('setRows', [])
    return []
  }
}

export const create = async (_, { automationId, body }) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.post(`service-automation/${automationId}/actions`, body)

    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const update = async (_, { id, body }) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.put(`service-automation/actions/${id}`, body)
    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const remove = async (_, id) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.delete(`service-automation/actions/${id}`)
    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

